import Link from 'next/link.js';

import { ThemeTitle } from 'components/v1/ui/ThemeTitle';

const Impressum = () => {
  return (
    <div>
      <ThemeTitle text="Impressum" />
      <br />
      <p>
        Vetopedia
        <br />
        Hauptstr. 72
        <br />
        9430 St.Margrethen
        <br />
        <b>Schweiz</b>
        <br />
        Tel.: +41 (0)71 888 14 31
        <br />
        E-Mail: <a href="mailto:kontakt@vetopedia.ch">kontakt@vetopedia.ch</a>
        <br />
        Website: <Link href="/">https://www.vetopedia.ch/</Link>
      </p>
      <br />
      <h6>
        <b>Verantwortlich für den Inhalt:</b>
      </h6>
      <p>Jeder Autor eines Video- oder Textbeitrages ist für den Inhalt seiner Publikation verantwortlich.</p>
      <p>
        <i>Kontaktperson:</i> Markus Knecht
      </p>
      <br />
      <h5>
        <b>Haftungsausschluss:</b>
      </h5>
      <p>
        Vetopedia veröffentlicht Berichte, welche auf den gewissenhaften Aussagen von betroffenen Personen oder von
        Zeugen beruhen. Die Artikel werden vor Veröffentlichung von der Vetopedia-Redaktion überprüft. In vielen Fällen
        ist eine lückenlose Prüfung der Ereignisse jedoch nicht möglich. Vetopedia übernimmt aus diesem Grund keine
        Verantwortung für die Richtigkeit der Zeugenberichte. Jeder Verfasser haftet selber für die von ihm verfassten
        Texte.
      </p>
      <p>
        Der Portalbetreiber übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit,
        Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen. Haftungsansprüche gegen den Autor wegen
        Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der
        veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind,
        werden ausgeschlossen. Alle Angebote sind unverbindlich. Der Portalbetreiber behält es sich ausdrücklich vor,
        Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder
        die Veröffentlichung zeitweise oder endgültig einzustellen.
      </p>
      <h5>
        <b>Haftung für Links:</b>
      </h5>
      <p>
        Haftung für Links - Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
        Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
        verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten
        Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren
        zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
        jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
        Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </p>
      <h5>
        <b>Anwendbares Recht:</b>
      </h5>
      <p>Die Benutzung dieser Webseite unterliegt Schweizer Recht.</p>
      <p>________________________________________</p>
      <p>
        Technische Probleme/Feedbacks zu dieser Internetpräsenz?{' '}
        <a
          rel="nofollow"
          class="external text"
          href="mailto:admin@vetopedia.ch"
        >
          admin@vetopedia.ch
        </a>
      </p>
    </div>
  );
};

export default Impressum;
